<rt-dropdown [width]="DropdownWidth.LargeXX" (click)="$event.stopPropagation()">
  <div class="header">
    <rt-heading variant="heading large">
      {{ 'app.candidate.share_dialog.heading' | translate }}
    </rt-heading>
    <rt-tabs [hasBottomSeparator]="false">
      <rt-tab
        [class.current]="activeTab === DropdownTab.TeamMembers"
        (click)="changeTab(DropdownTab.TeamMembers)"
      >
        {{ 'app.candidate.share_dialog.tabs.team_members' | translate }}
        <ng-container
          [ngTemplateOutlet]="counterBadgeTpl"
          [ngTemplateOutletContext]="{
            counter: sharedAdminCount,
            tooltipKey: 'app.candidate.share_dialog.team_members.shared_with_team_members',
          }"
          data-cy="candidate-sharing-dropdown:candidate-sharing-team-members-tab:counter"
        />
      </rt-tab>
      <rt-tab
        [class.current]="activeTab === DropdownTab.Anyone"
        (click)="changeTab(DropdownTab.Anyone)"
      >
        {{ 'app.candidate.share_dialog.tabs.anyone' | translate }}
        <ng-container
          [ngTemplateOutlet]="counterBadgeTpl"
          [ngTemplateOutletContext]="{
            counter: sharedContainerCount,
            tooltipKey: 'app.candidate.share_dialog.team_members.shared_via_public_link',
          }"
        />
      </rt-tab>
    </rt-tabs>
  </div>
  <div class="tabs">
    @if (viewReady) {
      @if (activeTab === DropdownTab.TeamMembers) {
        <rt-candidate-sharing-team-members-tab
          [currentUser]="currentUser"
          [candidate]="candidate"
          [companyId]="currentCompany.id"
          [sharingDisabled]="sharingDisabled"
          [sharedWithUsers]="candidateShare.sharedWith || []"
          [usersAlreadyWithAccess]="candidateShare.alreadyHaveAccess"
          (newItemClick)="newItemClick.emit()"
        />
      }
      @if (activeTab === DropdownTab.Anyone) {
        <rt-candidate-sharing-anyone-tab
          [candidate]="candidate"
          [currentCompany]="currentCompany"
          [containers]="candidateShare.containers"
          (newLinkClick)="openContainerDialog()"
          (editContainerClick)="openContainerDialog($event)"
          (addToExisting)="openContainerAssignmentsDialog()"
        />
      }
    }
    @if (!viewReady) {
      <rt-spinner />
    }
  </div>
</rt-dropdown>

<ng-template #counterBadgeTpl let-counter="counter" let-tooltipKey="tooltipKey">
  @if (counter > 0) {
    <rt-badge
      [rtTooltip]="tooltipKey | translate: { count: counter }"
      [rtTooltipEnabled]="counter > 0"
      [text]="counter"
      color="counter-default"
      margin-left-small-x
    />
  }
</ng-template>
